module.exports = __webpack_public_path__ + "img/dash-VARILUX-COMFORT_full_white.1a11d04f.png";